import { render, staticRenderFns } from "./subjectLibrary.vue?vue&type=template&id=4c3acafe&scoped=true"
import script from "./subjectLibrary.vue?vue&type=script&lang=js"
export * from "./subjectLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3acafe",
  null
  
)

export default component.exports